import { Overrides } from '@material-ui/core/styles/overrides';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';

export const scopedCssBaselineOverrides: Overrides = {
  MuiScopedCssBaseline: {
    root: {
      backgroundColor: CORPORATE_COLORS.WHITE
    }
  }
};
